import { render, staticRenderFns } from "./BullDisposal.vue?vue&type=template&id=b7b4c05c&scoped=true&"
import script from "./BullDisposal.vue?vue&type=script&lang=js&"
export * from "./BullDisposal.vue?vue&type=script&lang=js&"
import style0 from "./BullDisposal.vue?vue&type=style&index=0&id=b7b4c05c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b4c05c",
  null
  
)

export default component.exports